import type { RouterStatsResponse } from '@nadoutong/contracts';
import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { useSession } from '../hooks/useSession.tsx';
import { getRouterStats } from './routerStats.ts';

/**
 * React Query wrapper for router-stats.
 *
 * Query key includes `days` so switching the window in the Dashboard
 * dropdown cache-hits independently per selection.
 */

export const ROUTER_STATS_ROOT_KEY = ['router-stats'] as const;

export function routerStatsQueryKey(
  days: number,
): readonly ['router-stats', number] {
  return ['router-stats', days] as const;
}

export function useRouterStats(days: number): UseQueryResult<RouterStatsResponse> {
  const { fetchImpl } = useSession();
  return useQuery({
    queryKey: routerStatsQueryKey(days),
    queryFn: ({ signal }) => getRouterStats(days, fetchImpl, signal),
  });
}
